var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Question } from "./question";
import { Utility } from "app/shared/models/utility";
var ListQuestion = /** @class */ (function (_super) {
    __extends(ListQuestion, _super);
    function ListQuestion() {
        var _this = _super.call(this) || this;
        _this._customLabels = [];
        return _this;
    }
    Object.defineProperty(ListQuestion.prototype, "CustomLabels", {
        get: function () {
            return this._customLabels;
        },
        set: function (v) {
            this._customLabels = v;
        },
        enumerable: true,
        configurable: true
    });
    ListQuestion.prototype.addLabel = function (lbl) {
        this._customLabels.push(lbl);
    };
    ListQuestion.prototype.removeLabel = function (lbl) {
        this._customLabels = this._customLabels.filter(function (l) { return l.id != lbl.id; });
    };
    ListQuestion.prototype.shiftUpLabel = function (lbl) {
        Utility.shiftCollectionUp(this._customLabels, lbl);
    };
    ListQuestion.prototype.shiftDownLabel = function (lbl) {
        Utility.shiftCollectionDown(this._customLabels, lbl);
    };
    return ListQuestion;
}(Question));
export { ListQuestion };



// WEBPACK FOOTER //
// ./src/app/shared/models/list-question.ts.pre-build-optimizer.js